import { Link } from 'react-router-dom';

interface BreadcrumbItem {
  label: string;
  href?: string;
}

interface BreadcrumbProps {
  items: BreadcrumbItem[];
}

export default function Breadcrumb({ items }: BreadcrumbProps) {
  return (
    <nav aria-label="Fil d'Ariane" className="pt-20 md:pt-24 pb-2.5 md:pb-3 px-4 md:px-6 bg-white border-b border-background-200/60">
      <div className="max-w-7xl mx-auto">
        <ol className="flex items-center gap-1.5 text-xs md:text-sm whitespace-nowrap overflow-x-auto">
          {items.map((item, i) => (
            <li key={i} className="flex items-center gap-1.5 shrink-0">
              {i > 0 && (
                <span className="text-foreground-300 select-none shrink-0" aria-hidden="true">›</span>
              )}
              {item.href ? (
                <Link
                  to={item.href}
                  className="text-[#169873] hover:text-[#0e7a58] transition-colors cursor-pointer font-medium"
                >
                  {item.label}
                </Link>
              ) : (
                <span className="text-foreground-400 truncate max-w-[180px] md:max-w-[360px]">
                  {item.label}
                </span>
              )}
            </li>
          ))}
        </ol>
      </div>
    </nav>
  );
}